import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface FeedbackItem {
  id: string;
  booking_id: string;
  booking_date: string;
  feedback?: string;
  customer_notes?: string;
  reason?: string;
  signed_by?: string;
  signature?: string;
  [key: string]: any;
}

interface FeedbackState {
  items: FeedbackItem[];
  loading: boolean;
  error: string | null;
}

const initialState: FeedbackState = {
  items: [],
  loading: false,
  error: null,
};

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState,
  reducers: {
    // Action creators for Redux Offline
    addFeedback: (state, action: PayloadAction<FeedbackItem>) => {
      state.items = [action.payload, ...state.items];
    },
    addFeedbackCommit: (state) => {
      // Handle success if needed
    },
    addFeedbackFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    updateFeedback: (state, action: PayloadAction<FeedbackItem>) => {
      const index = state.items.findIndex(
        (item) => 
          action.payload.booking_id === item.booking_id && 
          action.payload.booking_date === item.booking_date
      );
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    updateFeedbackCommit: (state) => {
      // Handle success if needed
    },
    updateFeedbackFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      feedback?: FeedbackItem[];
      page?: number;
    }>) => {
      if (action.payload.page) {
        if (action.payload.feedback && action.payload.feedback.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, action.payload.feedback);
        }
      } else {
        state.items = action.payload.feedback || [];
      }
    });
  },
});

export const {
  addFeedback,
  addFeedbackCommit,
  addFeedbackFailed,
  updateFeedback,
  updateFeedbackCommit,
  updateFeedbackFailed,
} = feedbackSlice.actions;

export default feedbackSlice.reducer;

// Selectors
export const selectFeedbackByBooking = (state: any, bookingId: string, bookingDate: string) => {
  return state.feedback.items.find((feedback: FeedbackItem) => 
    feedback.booking_id === bookingId && 
    feedback.booking_date === bookingDate
  );
};

export const selectCheckinByBooking = (state: any, bookingId: string, bookingDate: string) => {
  return state.checkins.items.find((checkin: any) => 
    checkin.booking_id === bookingId && 
    checkin.booking_date === bookingDate
  );
};